import styled, { css } from 'foundations-theming/utils';
const getHighlightBorder = theme => `border-right: ${theme.borderWidth['200']} solid ${theme.color['fill-info-default']};`;
const size = css(["inline-size:", ";block-size:100%;"], ({
  theme
}) => theme.space['250']);
export const ResizeAffordance = styled.div.withConfig({
  displayName: "ResizeAffordance"
})(["", " cursor:col-resize;", " &:hover{", "}"], size, ({
  $shouldHighlight,
  theme
}) => $shouldHighlight ? getHighlightBorder(theme) : '', ({
  theme
}) => getHighlightBorder(theme));
export const ResizeAffordanceSpace = styled.div.withConfig({
  displayName: "ResizeAffordance__ResizeAffordanceSpace"
})(["", ""], size);